import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import withStyles from '@mui/styles/withStyles';
import { Button, Checkbox, FormControlLabel, Grid, Paper, Table, TableBody, TableContainer, TableCell, TableRow, TextField, Typography
} from '@mui/material';
import { formatISO } from 'date-fns';

import AbEnvironment from '../auth/AbEnvironment';
import CountrySelect from '../ui/CountrySelect'
import RegionSelect from '../ui/RegionSelect'
import AdminDashboard from './AdminDashboard';
import CustomerDashboard from './CustomerDashboard';
import Email from '@mui/icons-material/Email';
import VendorDashboard from './VendorDashboard';
import Dashboard from './Dashboard';
import LoadingSpinner from '../ui/LoadingSpinner';
import AssentDialog from './AssentDialog';
import SaveButton from '../ui/SaveButton';
import AccountConfirmUpdateMutation from '../account/AccountConfirmUpdateMutation';
import UserConfirmUpdateMutation from '../account/UserConfirmUpdateMutation';

const abEnvironment = new AbEnvironment();
const styleSheet = theme => ({
  root: {
    //marginLeft: -210,
    flexGrow: 1,
    padding: 20,
    position: 'absolute',
    top: '50px',
    left: '0px',
    width: 'calc(100% - 40px)',
  },
  rootLoggedIn: {
    flexGrow: 1,
    padding: 20,
    marginLeft: 0,
  },
  flex: {
    flex: 1,
  },
  button: {
    margin: theme.spacing(1),
  },
  panelTitle: {
    flex: 1,
    padding: 12,
    marginLeft: 15,
    marginTop: 10,
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },
  select: {
    marginLeft: -8,
    marginTop: -8,
  },
  descriptiveText: {
    textAlign: 'left',
  },
  paperOuter: {
    marginTop: 32,
    paddingTop: 20,
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom: 30
  },
  paper: {
    marginTop: 32,
    paddingTop: 16,
    paddingLeft: 10,
    paddingRight: 10,
    paddingBottom: 20
  },
  emailIcon: {
    width: 30,
    height: 30,
  },
  logoContainer: {
    display: 'flex',
    height: '50px',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 12,
  },
  tableContainer: {
    boxShadow: "none"
  },
  powerByCell: {
    padding: 0,
    borderBottom: "none"
  }
});

class Home extends Component {
  state = {
    unAuthRender: <LoadingSpinner/>,
    dialogOpen:  this.showAssentDialog(),
    saveStatus:  null,
    saveMessage: null,
    saveSnackbarOpen: false,
    saveSnackbarDuration: null,
    accountName: abEnvironment.getUserAttribute('a_accountName'),
    firstName:   abEnvironment.getUserAttribute('u_firstName'),
    lastName:    abEnvironment.getUserAttribute('u_lastName'),
    address1:    (abEnvironment.getUserAttribute('u_address1') ? abEnvironment.getUserAttribute('u_address1') : abEnvironment.getUserAttribute('a_address1')),
    address2:    (abEnvironment.getUserAttribute('u_address2') ? abEnvironment.getUserAttribute('u_address2') : abEnvironment.getUserAttribute('a_address2')),
    city:        (abEnvironment.getUserAttribute('u_city') ? abEnvironment.getUserAttribute('u_city') : abEnvironment.getUserAttribute('a_city')),
    state:       (abEnvironment.getUserAttribute('u_state') ? abEnvironment.getUserAttribute('u_state') : abEnvironment.getUserAttribute('a_state')),
    country:     (abEnvironment.getUserAttribute('u_country') ? abEnvironment.getUserAttribute('u_country') : abEnvironment.getUserAttribute('a_country')),
    postalCode:  (abEnvironment.getUserAttribute('u_postalCode') ? abEnvironment.getUserAttribute('u_postalCode') : abEnvironment.getUserAttribute('a_postalCode')),
    affirm:      false,
    accepted:    false,
  }

  goTo(route) {
    this.props.history.push(`/${route}`);
  }

  login() {
    this.props.auth.login();
  }

  signup() {
    this.props.auth.signup(null);
  }

  needEmailVerification() {
    if (abEnvironment.getUserAttribute('email_verified') !== 'true') {
      return true;
    }
    return false;
  }

  showAssentDialog() {
    const { isAuthenticated } = this.props.auth;
    if (isAuthenticated() && (this.needAssent() || this.needEmailVerification())) {
      return true;
    }
    return false;
  }

  showAccountConfirm() {
    let uacd = abEnvironment.getUserAttribute('a_accountCDate');
    if (uacd == null || uacd === '')
      return true;

    return false;
  }
  showUserConfirm() {
    /* */
    let uucd = abEnvironment.getUserAttribute('u_userCDate');
    if (uucd == null || uucd === '')
      return true;

    return false;
    /* */
    //return true;
  }
  showTermsConfirm() {
    let utd = abEnvironment.getUserAttribute('u_termsDate');
    if (utd == null || utd === '')
      return true;

    return false;
  }

  onlyNeedTerms() {
    if (this.showTermsConfirm() && ! this.showAccountConfirm() && ! this.showUserConfirm()) {
      return true;
    }
    return false;
  }

  needAssent() {
    if (this.showAccountConfirm() || this.showUserConfirm() || this.showTermsConfirm()) {
      return true;
    }
    return false;
  }

  
  isFromSubcriptionOrderLanding() {
    var fromLanding = localStorage.getItem('subscriptionOrderComplete');
    if (fromLanding) {
      localStorage.removeItem('subscriptionOrderComplete');
      return true;
    }
    return false;
  }

  isFromSubcriptionOrderLogin() {
    var fromSubOrderLogin = localStorage.getItem('subscriptionOrderLogin');
    if (fromSubOrderLogin) {
      return true;
    }
    return false;
  }

  getSubcriptionOrderUrl() {
    var fromSubOrderLogin = localStorage.getItem('subscriptionOrderLogin');
    if (fromSubOrderLogin) {
      localStorage.removeItem('subscriptionOrderLogin');
      let returnUrl = '/order/' + fromSubOrderLogin
      return returnUrl;
    }
  }

  needAssentOrVerification() {
 
    if (this.needAssent() || this.needEmailVerification()) {
      return true;
    }
    return false;
  }


  disableSave = () => {
    let retval = false;

    if (this.showAccountConfirm() && (this.state.accountName == null || this.state.accountName === ''))
      retval = true;

    if (this.showUserConfirm() &&
        (this.state.firstName  == null || this.state.firstName  === '' ||
         this.state.lastName   == null || this.state.lastName   === '' ||
         this.state.address1   == null || this.state.address1   === '' ||
         this.state.city       == null || this.state.city       === '' ||
         this.state.state      == null || this.state.state      === '' ||
         this.state.country    == null || this.state.country    === '' ||
         this.state.postalCode == null || this.state.postalCode === ''   ) )
      retval = true;

    if (this.showUserConfirm() && this.state.affirm === false)
      retval = true;

    if (this.showTermsConfirm() && this.state.accepted === false)
      retval = true;

    if (retval) {
      if (this.state.saveStatus != null || this.state.saveMessage != null) {
        this.setState({saveStatus: null, saveMessage: null});
      }
    }

    return retval;
  }

  acceptTerms() {
    const { callPartnerApi } = this.props.auth;

    this.setState({ saveStatus: 'saving', saveMessage: '' });

    // If this is just a term update, the only thing to do is set the term accept date
    // on the user.
    let theHome = this;
    let userId = abEnvironment.getUserAttribute('u_id');
    let nowdate = formatISO(new Date());

    if (this.onlyNeedTerms()) {
      Promise.resolve()
      .then(() => {
        return UserConfirmUpdateMutation.commit(
          userId,
          null, null, null, null, null, null, null, null, null,
          nowdate);
      })
      .then(resp => {

        abEnvironment.setUserAttribute('u_termsDate', nowdate);
        theHome.setState({ saveStatus: 'success', saveMessage: 'Changes Confirmed.'});
      })
      .catch(err => {
        theHome.setState({ saveStatus: 'error', saveMessage: 'An error occurred while saving; please try again.' });
        window.location.reload();
      });
    } else {
      const { accountName, lastName, firstName, address1, address2, city, state, country, postalCode } = this.state;

      let accountId = abEnvironment.getUserAttribute('a_id');
      let accountType = abEnvironment.getUserAttribute('a_aType');

      let aAccountName = null;
      let aConfDate = null;
      let uLastName = null;
      let uFirstName = null;
      let uAddress1 = null;
      let uAddress2 = null;
      let uCity = null;
      let uState = null;
      let uCountry = null;
      let uPostalCode = null;
      let uConfDate = null;
      let uTermsDate = null;

      let setValuesOnAccount = false;

      Promise.resolve()
      .then(() => {
        if (theHome.showAccountConfirm()) {
          // Save account info
          aAccountName = accountName;
          aConfDate = nowdate;

          // On a self-serve signup, use the user information to preset the contact on the account.
          // On an invite, the user information should only be set on the account if there isn't already
          // data set.
          if ( (abEnvironment.getUserAttribute('a_lastName')   != null && abEnvironment.getUserAttribute('a_lastName') !== '')  ||
               (abEnvironment.getUserAttribute('a_firstName')  != null && abEnvironment.getUserAttribute('a_firstName') !== '') ||
               (abEnvironment.getUserAttribute('a_address1')   != null && abEnvironment.getUserAttribute('a_address1') !== '')  ||
               (abEnvironment.getUserAttribute('a_address2')   != null && abEnvironment.getUserAttribute('a_address2') !== '')  ||
               (abEnvironment.getUserAttribute('a_city')       != null && abEnvironment.getUserAttribute('a_city') !== '')      ||
               (abEnvironment.getUserAttribute('a_state')      != null && abEnvironment.getUserAttribute('a_state') !== '')     ||
               (abEnvironment.getUserAttribute('a_country')    != null && abEnvironment.getUserAttribute('a_country') !== '')   ||
               (abEnvironment.getUserAttribute('a_postalCode') != null && abEnvironment.getUserAttribute('a_postalCode') !== '') )
          {
            setValuesOnAccount = true;
            return AccountConfirmUpdateMutation.commit(accountId, aAccountName, aConfDate,
                                                       lastName, firstName, address1, address2, city, state, country, postalCode);
          }
          else
          {
            return AccountConfirmUpdateMutation.commit(accountId, aAccountName, aConfDate,
                                                       null, null, null, null, null, null, null, null);
          }
        } else {
          return null;
        }
      })
      .then(() => {
        if (theHome.showUserConfirm()) {
          uLastName = lastName;
          uFirstName = firstName;
          uAddress1 = address1;
          uAddress2 = address2;
          uCity = city;
          uState = state;
          uCountry = country;
          uPostalCode = postalCode;
          uConfDate = nowdate;
        }
        if (theHome.showTermsConfirm()) {
          uTermsDate = nowdate;
        }

        if (uConfDate != null || uTermsDate != null) {
          return UserConfirmUpdateMutation.commit(
            userId,
            uLastName, uFirstName, uAddress1, uAddress2, uCity, uState, uCountry, uPostalCode, uConfDate,
            uTermsDate);
        }
        else
        {
          return null;
        }
      })
      .then((resp) => {
        // Removed Hubspot, ActiveCampaign in process
        let payload = {
          operation: "asyncLinkAccountToActiveCampaign",
          params: {
            accountId: accountId
          }
        };
    
        if (accountType === '3') {
          return callPartnerApi('appbind/generic', 'POST', payload);
        } else {
          return null;
        }  
      })
      .then(() => {
        if (aAccountName != null)
          abEnvironment.setUserAttribute('a_accountName', aAccountName);
        if (aConfDate != null)
          abEnvironment.setUserAttribute('a_accountCDate', aConfDate);

        if (setValuesOnAccount) {
          if (lastName != null)
            abEnvironment.setUserAttribute('a_lastName', lastName);
          if (firstName != null)
            abEnvironment.setUserAttribute('a_firstName', firstName);
          if (address1 != null)
            abEnvironment.setUserAttribute('a_address1', address1);
          if (address2 != null)
            abEnvironment.setUserAttribute('a_address2', address2);
          if (city != null)
            abEnvironment.setUserAttribute('a_city', city);
          if (state != null)
            abEnvironment.setUserAttribute('a_state', state);
          if (country != null)
            abEnvironment.setUserAttribute('a_country', country);
          if (postalCode != null)
            abEnvironment.setUserAttribute('a_postalCode', postalCode);
        }

        if (uLastName != null)
          abEnvironment.setUserAttribute('u_lastName', uLastName);
        if (uFirstName != null)
          abEnvironment.setUserAttribute('u_firstName', uFirstName);

        if (uAddress1 != null)
          abEnvironment.setUserAttribute('u_address1', uAddress1);
        if (uAddress2 != null)
          abEnvironment.setUserAttribute('u_address2', uAddress2);
        if (uCity != null)
          abEnvironment.setUserAttribute('u_city', uCity);
        if (uState != null)
          abEnvironment.setUserAttribute('u_state', uState);
        if (uCountry != null)
          abEnvironment.setUserAttribute('u_country', uCountry);
        if (uPostalCode != null)
          abEnvironment.setUserAttribute('u_postalCode', uPostalCode);

        if (uConfDate != null)
          abEnvironment.setUserAttribute('u_userCDate', uConfDate);
        if (uTermsDate != null)
          abEnvironment.setUserAttribute('u_termsDate', uTermsDate);

        if (this.needEmailVerification()) {
          theHome.setState({ saveStatus: 'success', saveMessage: 'Changes Confirmed.'});
        } else {
          theHome.setState({ saveStatus: 'success', saveMessage: 'Changes Confirmed.', dialogOpen: false});
        }
      })
      .catch(err => {
        theHome.setState({ saveStatus: 'error', saveMessage: 'An error occurred while saving; please try again.' });
        window.location.reload();
      });
    }
  }


  getPasswordTicket(username)
  {
    const { callPartnerApi } = this.props.auth;

    return new Promise(function(resolve, reject) {
      callPartnerApi('appbind/invitetoken/' + username,
                     'GET',
                     null,
                     true)
      .then(response => {
        return response.json();
      })
      .then(data => {
        let theLink = data.link;
        resolve(theLink);
      })
      .catch(err => {
        // console.log('err');
        reject(err);
      });
    });
  }

  getLoginContent(theMode, theWelcomeText, theBodyText) {
    const classes = this.props.classes;
    if (theMode === 'loginAndSignup') {
      return (
        <div className={classes.root}>
          <Grid container direction="column" alignItems="center" spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h4" className={classes.flex}>{theWelcomeText}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1" className={classes.flex}style={{marginBottom:'15px'}}>{theBodyText}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Grid container direction="row" alignItems="center" spacing={2}>
                <Grid item>
                  <Button color="primary" variant="outlined" onClick={this.login.bind(this)}>Log in</Button>
                </Grid>
                <Grid item>
                  <Typography variant="body1">or</Typography>
                </Grid>
                <Grid item>
                  <Button color="primary" variant="contained" onClick={this.signup.bind(this)}>Sign up</Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      );
    } else {
      return (
        <div className={classes.root}>
          <Grid container direction="column" alignItems="center" spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h4" className={classes.flex}>{theWelcomeText}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1" className={classes.flex}style={{marginBottom:'15px'}}>{theBodyText}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Button color="primary" variant="contained"onClick={this.login.bind(this)}>Log in</Button>
            </Grid>
          </Grid>
        </div>
      );
    }
  }

  componentDidMount() {
    const { isAuthenticated } = this.props.auth;

    if (! isAuthenticated()) {
      let theHome = this;
      const params = new URLSearchParams(this.props.location.search);
      let theMessage = params.get("message");
      let theEmail = params.get("email");
      Promise.resolve()
      .then(() => {
        if (theEmail != null && theMessage != null)
        {
          if (theMessage.includes("verified"))
          {
            // transform to username
            let theUsername = theEmail.replace('@', '-');
            if (theUsername != null)
            {
              // call to get redirect link
              return theHome.getPasswordTicket(theUsername);
            }
            else
            {
              // Unlikely case
              return "verified";
            }
          }
          else if (theMessage.includes("login"))
          {
            return "login";
          }
        }
        return null;
      })
      .then(redirectLink => {
        if (redirectLink != null) {
          if (redirectLink === "login")
          {
            let theContent =
              theHome.getLoginContent('login',
                                      'Welcome to AppBind!',
                                      'You can now log into AppBind using your new password.  Please log in to continue.');
            theHome.setState({unAuthRender: theContent});
          } else if (redirectLink === "verified") {
              let theContent =
                theHome.getLoginContent('login',
                                        'Welcome to AppBind!',
                                        'Thank you for verifying your email address.  Please log in to continue.');
              theHome.setState({unAuthRender: theContent});
          } else {
            window.location = redirectLink;
          }
        }
        else
        {
          // If verified, indicate...
          if (theMessage != null && theMessage.includes("verified")) {
            let theContent =
              theHome.getLoginContent('login',
                                      'Welcome to AppBind!',
                                      'Thank you for verifying your email address.  Please log in to continue.');
            theHome.setState({unAuthRender: theContent});
          } else {
            let theContent =
              theHome.getLoginContent('loginAndSignup',
                                      'Welcome to AppBind!',
                                      'You are not logged in.  Please log in to continue.');
            theHome.setState({unAuthRender: theContent});
          }
        }
      })
      .catch(err => {
        let theContent =
          theHome.getLoginContent('loginAndSignup',
                                  'Welcome to AppBind!',
                                  'You are not logged in.  Please log in to continue.');
        theHome.setState({unAuthRender: theContent});
      });
    }
    else
    {
      if (abEnvironment.getUserAttribute('email_verified') !== 'true') {
        const params = new URLSearchParams(this.props.location.search);
        let theMessage = params.get("message");
        let theEmail = params.get("email");
        if (theEmail != null && theMessage != null && theMessage.includes("verified"))
        {
          abEnvironment.setUserAttribute('email_verified', 'true');
          this.setState({dialogOpen: this.showAssentDialog()});
        }
      }
    }
  }

  setCountryCodeState = (theCountryCode) => {
    this.setState({country: theCountryCode});
  }

  setRegionCodeState = (theRegionCode) => {
    this.setState({state: theRegionCode});
  }

  render() {
    const { isAuthenticated, isAuthenticatedCustomer, isUnauthenticatedCustomer,
            isAuthenticatedReseller, isAuthenticatedAppBind, isAuthenticatedVendor, getAccountUUID } = this.props.auth;
    const classes = this.props.classes;

    const termsChanged = `
      We've updated the AppBind terms of service.  Please review these terms and confirm that you accept them.
    `;
    const theWelcome = `
      AppBind manages the billing and expensing of online services you purchase for yourself and your clients.
    `;
    const theWelcomeUnAuth = `
    AppBind manages the billing and expensing of online services purchased on your behalf.
    `;
    const theWelcome2 = `
      AppBind works by creating virtual credit cards to buy each online service subscription.  We need to
      confirm your accurate contact information to create credit cards you can use.
    `;
    const theWelcome2UnAuth = `
    AppBind works by creating virtual credit cards to purchase online services on your behalf, and relies on trusted platforms to securely connect your funding to these virtual credit cards. 
    Please confirm your contact information, and grant us permission to continue by accepting our Terms of Service and Privacy Policy.
    `;

    if (isAuthenticated()) {
      // If the user has not yet assented to terms of service, show an overlay to collect assent along with
      // other getting started information.  This is also shown if email verification is still needed.
      //
      // So three possibilities:
      //  1) Need assent and confirmation
      //   - show the main welcome
      //  2) Need just assent
      //   - show the "Terms have changed" welcome
      //  3) Need email verification
      //   - show the email verification
      //
      if (this.needAssentOrVerification())
      {
        let assentTitle = "Let's get started";
        let titleBlock = "AssentAndEmailConfirm";
        let buttonText = "Get Started!";
        
        if (!this.needAssent() && this.needEmailVerification()) {
          assentTitle = "Welcome! Let's get started.";
          titleBlock = "EmailConfirm";
        }

        // Terms only
        if (this.onlyNeedTerms()) {
          assentTitle = "Our terms have changed";
          titleBlock = "AssentOnly";
          buttonText = "Confirm";
        }

        if (titleBlock === 'EmailConfirm') {
          return (
            <Redirect to='/welcome' />
          );
        
        }

        return (
          <AssentDialog
            title={assentTitle}
            open={this.state.dialogOpen}
          >
            <Grid container spacing={2} direction="row" justifyContent="flex-start">
              { titleBlock === 'AssentOnly' &&
              <Grid item xs={12}>
                <Typography variant="body1" className={classes.descriptiveText}>
                  {termsChanged}
                </Typography>
              </Grid> }
              { titleBlock === 'AssentAndEmailConfirm' && !isUnauthenticatedCustomer() &&
              <Grid item xs={12}>
                <Typography variant="body1" className={classes.descriptiveText}>
                  {theWelcome}
                </Typography>
              </Grid> }
              { titleBlock === 'AssentAndEmailConfirm' && isUnauthenticatedCustomer() &&
              <Grid item xs={12}>
                <Typography variant="body1" className={classes.descriptiveText}>
                  {theWelcomeUnAuth}
                </Typography>
              </Grid> }
              { titleBlock === 'AssentAndEmailConfirm' &&
              <Grid item xs={12}>
                <Typography variant="h6" >
                  Please confirm your contact information
                </Typography>
              </Grid> }
              { titleBlock === 'AssentAndEmailConfirm' && !isUnauthenticatedCustomer() &&
              <Grid item xs={12}>
                <Typography variant="body1" className={classes.descriptiveText}>
                  {theWelcome2}
                </Typography>
              </Grid> }
              { titleBlock === 'AssentAndEmailConfirm' && isUnauthenticatedCustomer() &&
              <Grid item xs={12}>
                <Typography variant="body1" className={classes.descriptiveText}>
                  {theWelcome2UnAuth}
                </Typography>
              </Grid> }

              { titleBlock === 'EmailConfirm'  &&
                  <React.Fragment>
                  <Grid container spacing={0} align="center" justifyContent="center" alignItems="center">
                     <Paper style={{border:'solid #eee 8px', background:'#f8f8f8'}} className={classes.paper} elevation={1} >
                     
                      <Grid item style={{padding:'32px'}}>
                    
                        <Email style={{width:'64px', height:'64px', color:'#7d54ea'}} htmlColor={'primary'} className={classes.emailIcon} />
                              
                        
                        <Typography variant="h5" >
                          <strong>Verify your email</strong>
                        </Typography>
                        <Typography variant="h6" style={{marginTop: '16px'}}>
                          Look for an email from <strong style={{color: '#7d54ea'}}>AppBind</strong>.<br></br>Click the button!
                        </Typography>
                      </Grid>
                    </Paper>
                  </Grid>

                  <Grid container spacing={0} align="center" justifyContent="center" alignItems="center">
                    <Grid item style={{marginTop: '16px'}}>
                      <TableContainer className={classes.tableContainer} >
                      <Table>
                        <TableBody>
                          <TableRow>
                            <TableCell className={classes.powerByCell}><Typography variant="caption">Powered by</Typography></TableCell>
                            <TableCell  className={classes.powerByCell}>
                                <div className={classes.logoContainer}>
                                  <img alt="AppBind Logo" height="30px" src={'https://app.appbind.com/logos/appbind-logo-c-b.png'} />
                                </div>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                      </TableContainer>
                    </Grid>
                  </Grid>
               </React.Fragment>

              }

              { this.showUserConfirm() && ! this.showAccountConfirm() &&
              <Grid item xs={12}>
                <Typography variant="subtitle1">
                  Name
                </Typography>
              </Grid>
              }
              { this.showUserConfirm() && this.showAccountConfirm() &&
              <Grid item xs={12}>
                <Typography variant="subtitle1">
                  Name / Company
                </Typography>
              </Grid>
              }
              { this.showUserConfirm() &&
              <Grid item xs={6}>
              <TextField data-recording-ignore="mask"
                  id="firstName" label="First Name" 
                  value={this.state.firstName}
                  onChange={ (e) => this.setState({ firstName: e.target.value }) }
                  inputProps={{ maxLength: 32 }}
                />
              </Grid>
              }
              { this.showUserConfirm() &&
              <Grid item xs={6}>
              <TextField data-recording-ignore="mask"
                  id="lastName" label="Last Name"
                  value={this.state.lastName}
                  onChange={ (e) => this.setState({ lastName: e.target.value }) }
                  inputProps={{ maxLength: 32 }}
                />
              </Grid>
              }
              { this.showAccountConfirm() &&
              <Grid item xs={12}>
              <TextField
                  id="accountName" label="Company Name"
                  value={this.state.accountName}
                  onChange={ (e) => this.setState({ accountName: e.target.value }) }
                  inputProps={{ maxLength: 64 }}
                />
              </Grid>
              }
              { this.showUserConfirm() &&
              <Grid item xs={12}>
                <Typography variant="subtitle1">
                  Billing Address
                </Typography>
              </Grid>
              }
              { this.showUserConfirm() &&
              <Grid item xs={6}>
                <div className={classes.select}>
                  <CountrySelect
                    countryCode={this.state.country}
                    setCountryCodeState={this.setCountryCodeState}
                    widthOverride='97%'
                  />
                </div>
              </Grid>
              }
              { this.showUserConfirm() &&
              <Grid item xs={6}>
                <div className={classes.select}>
                  <RegionSelect
                    countryCode={this.state.country}
                    regionCode={this.state.state}
                    setRegionCodeState={this.setRegionCodeState}
                    widthOverride='97%'
                  />
                </div>
              </Grid>
              }
              { this.showUserConfirm() &&
              <Grid item xs={12}>
                <TextField data-recording-ignore="mask"
                  id="address1" label="Address 1"
                  value={this.state.address1}
                  onChange={ (e) => this.setState({ address1: e.target.value }) }
                  inputProps={{ maxLength: 64 }}
                />
              </Grid>
              }
              { this.showUserConfirm() &&
              <Grid item xs={12}>
                <TextField data-recording-ignore="mask"
                  id="address2" label="Address 2"
                  value={this.state.address2}
                  onChange={ (e) => this.setState({ address2: e.target.value }) }
                  inputProps={{ maxLength: 64 }}
                />
              </Grid>
              }
              { this.showUserConfirm() &&
              <Grid item xs={6}>
                <TextField data-recording-ignore="mask"
                  id="city" label="City"
                  value={this.state.city}
                  onChange={ (e) => this.setState({ city: e.target.value }) }
                  inputProps={{ maxLength: 64 }}
                />
              </Grid>
              }
              { this.showUserConfirm() &&
              <Grid item xs={6}>
                <TextField data-recording-ignore="mask"
                  id="postalCode" label="Postal Code"
                  value={this.state.postalCode}
                  onChange={ (e) => this.setState({ postalCode: e.target.value }) }
                  inputProps={{ maxLength: 10 }}
                />
              </Grid>
              }
              { this.showUserConfirm() &&
              <Grid item xs={12} className={classes.descriptiveText}>
                <FormControlLabel
                  control={<Checkbox
                    checked={this.state.affirm}
                    value="affirm"
                    onChange={ (e) => this.setState({ affirm: e.target.checked }) }
                  />}
                  label="I affirm that my contact information is accurate and is not misrepresented"
                />
              </Grid>
              }
              { this.showTermsConfirm() &&
              <Grid item xs={12} className={classes.descriptiveText}>
                <FormControlLabel
                  control={<Checkbox
                    checked={this.state.accepted}
                    value="accepted"
                    onChange={ (e) => this.setState({ accepted: e.target.checked }) }
                  />}
                  label={
                    <div>
                      <span>I accept the </span>
                      <a target="_blank" rel="noopener noreferrer" href="http://www.appbind.com/terms">AppBind Terms of Service</a>
                      <span> and </span>
                      <a target="_blank" rel="noopener noreferrer" href="http://www.appbind.com/privacy">Privacy Policy</a>
                    </div>}
                />
              </Grid>
              }
              { this.needAssent() &&
              <Grid item xs={12}>
                <SaveButton
                  snackbarOpen={this.state.saveSnackbarOpen}
                  autoHideDuration={this.state.saveSnackbarDuration}
                  status={this.state.saveStatus}
                  message={this.state.saveMessage}
                  label={buttonText}
                  disabled={this.disableSave()}
                  onSaveClick={() => {this.acceptTerms()}}
                />
              </Grid> }
              {/* For dev - logout without having to complete form
              <Grid item xs={12}>
                <SaveButton
                  label="Logout"
                  onClick={() => {logout()}}/>
              </Grid>
              */}
              { titleBlock === 'AssentAndEmailConfirm' && this.needEmailVerification() &&
              <Grid item xs={12}>
                <Typography variant="body1" className={classes.descriptiveText}>
                  After confirming, please check your email for a welcome email from AppBind.  
                  This email contains a link to verify your email address and activate
                  your new AppBind account.
                </Typography>
              </Grid>
              }
            </Grid>
          </AssentDialog>
        );
      } else {
        if (isAuthenticatedAppBind()) {
          return (
            <AdminDashboard history={this.props.history} auth={this.props.auth} />
          );
        } else if (isAuthenticatedReseller()) {
          if (this.isFromSubcriptionOrderLanding()) {
            var subscriptionLink = '/subscriptionorder'
            return (
              <Redirect to={subscriptionLink}  />
            );
  
          } else if (this.isFromSubcriptionOrderLogin()) {
            return (
              <Redirect to={this.getSubcriptionOrderUrl()} />
            );
          } else {
            return (
              <div>
                {/* <PageTitle title="Dashboard"/> */}
                <Dashboard resellerId={getAccountUUID()} history={this.props.history} auth={this.props.auth} />
              </div>
            );
  
          }
        } else if (isAuthenticatedCustomer()) {
          return (
            <div>
              {/* <PageTitle title="Dashboard"/> */}
              <CustomerDashboard accountId={getAccountUUID()} history={this.props.history} auth={this.props.auth} />
            </div>
          );
        } else if (isAuthenticatedVendor()) {
          return (
            <div>
              {/* <PageTitle title="Dashboard"/> */}
              <VendorDashboard history={this.props.history} auth={this.props.auth} />
            </div>
          );
        } else if (isUnauthenticatedCustomer()) {
          // Unauth customer
          return(<Redirect to='/fundingsources' />);
        } else {
          return (
            <div className={classes.rootLoggedIn}>
              <h4>
                You do not have access to this page.
              </h4>
            </div>
          );
        }
      }
    } else {
      return (
        <div>{this.state.unAuthRender}</div>
      );
    }
  }
}

Home.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(Home);
